import { Link, useLocation } from 'react-router-dom';
import { BorderedContainer } from '../../common/BorderedContainer';
import { Patient } from 'core/models/jianList/patients';
import { Incident } from 'core/models/jianList/incident';

type Props = {
  /** 傷病者情報 */
  patient: Patient;
  /** 救急隊名 */
  emsTeamName: Incident['emsTeamName'];
  /** 急送住所 */
  telegramTargetAddress: Incident['telegramTargetAddress'];
  /** 事案ID */
  incidentId: Incident['incidentId'];
  /** 選択された日付 */
  selectedDate: { startDate: Date | null; endDate: Date | null };
};

/** 日付をフォーマットする関数 */
const formatDate = (date: Date | null): string => {
  if (date === null) {
    return '';
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/** 傷病者のカードコンポーネント */
export const InjuredPersonCard = ({
  patient,
  emsTeamName,
  telegramTargetAddress,
  incidentId,
  selectedDate,
}: Props) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const selectedDateParam = params.get('selected-date');
  const searchQuery = params.get('search');
  const page = params.get('page');

  // 詳細URLの構築
  const queryParams = new URLSearchParams();
  if (selectedDateParam) {
    queryParams.set('selected-date', selectedDateParam);
  } else if (selectedDate.startDate) {
    queryParams.set('selected-date', formatDate(selectedDate.startDate));
  }

  if (searchQuery !== null && searchQuery !== '') {
    queryParams.set('search', searchQuery);
  }
  if (page) queryParams.set('page', page);

  const detailUrl = `/jian-detail/${incidentId}/${patient.patientId}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

  return (
    <Link to={detailUrl}>
      <BorderedContainer>
        <div className="flex justify-between items-center">
          <div className="flex flex-col gap-[8px]">
            <div className="flex flex-wrap gap-x-[16px] gap-y-[8px]">
              <TextPrimary text={patient.age ? `${patient.age}歳` : ''} />
              <TextPrimary text={patient.sex} />
              <TextPrimary text={patient.patientName} />
              <TextPrimary text={emsTeamName} />
            </div>
            <div className="flex flex-wrap gap-x-[16px] gap-y-[8px]">
              <TextSecondary text={`主訴: ${patient.chiefComplaint}`} />
            </div>
            <TextSecondary text={`出動場所: ${telegramTargetAddress}`} />
            <TextSecondary
              text={`収容施設: ${patient.receivingHospitalName}`}
            />
          </div>
        </div>
      </BorderedContainer>
    </Link>
  );
};

type TextPrimaryProps = {
  /** テキスト */
  text: string | null;
};

const TextPrimary = ({ text }: TextPrimaryProps) => {
  return text ? (
    <p className="text-[20px] noto-sans-jp-bold text-textPrimary">{text}</p>
  ) : (
    <></>
  );
};

type TextSecondaryProps = {
  /** テキスト */
  text: string | null;
};

const TextSecondary = ({ text }: TextSecondaryProps) => {
  return text ? (
    <p className="text-[14px] noto-sans-jp-regular text-textSecondary">
      {text}
    </p>
  ) : (
    <></>
  );
};
